import { getAuthTokenAsync } from "src/store/common";
import { Post, Meta } from "src/store/types";
import * as api from "./api";

interface ApiResponse {
  data: Post[];
  meta: Meta;
}

// fetch reel list
export const fetchReelList = async (data: {
  page: number;
  limit: number;
  search?: string;
}): Promise<ApiResponse> => {
  const params: any = {
    page: data.page,
    limit: data.limit,
  };

  if (data.search && data.search.trim()) {
    params.search = data.search.trim();
  }

  const token = getAuthTokenAsync();
  api.setHeaderAuthorization(token);
  const response: any = await api.get(
    `${process.env.REACT_APP_ADMIN_API_URL}/reel`,
    params,
  );
  return response;
};

// fetch reported reels
export const fetchReportedReels = async (data: {
  page: number;
  limit: number;
  search?: string;
}): Promise<ApiResponse> => {
  const params: any = {
    page: data.page,
    limit: data.limit,
  };

  if (data.search && data.search.trim()) {
    params.search = data.search.trim();
  }

  const token = getAuthTokenAsync();
  api.setHeaderAuthorization(token);
  const response: any = await api.get(
    `${process.env.REACT_APP_ADMIN_API_URL}/reel/reported-reel`,
    params,
  );
  return response;
};

// fetch reel reports
export const fetchReelReports = async (pid: string) => {
  const token = getAuthTokenAsync();
  api.setHeaderAuthorization(token);
  const response: any = await api.get(
    `${process.env.REACT_APP_ADMIN_API_URL}/reel/reported-reel/${pid}`,
  );
  return response;
};

// block/unblock reel
export const blockUnblockReel = (pid: string) => {
  const token = getAuthTokenAsync();
  api.setHeaderAuthorization(token);
  return api.get(`${process.env.REACT_APP_ADMIN_API_URL}/reel/${pid}`);
};

// pin/unpin reel
export const pinUnpinReel = (pid: string) => {
  const token = getAuthTokenAsync();
  api.setHeaderAuthorization(token);
  return api.patch(`${process.env.REACT_APP_ADMIN_API_URL}/reel/${pid}`);
};

// delete reel
export const deleteReel = (pid: string) => {
  const token = getAuthTokenAsync();
  api.setHeaderAuthorization(token);
  return api.remove(`${process.env.REACT_APP_ADMIN_API_URL}/reel/${pid}`);
};
